<template>
  <div class="logo">
    <div ref="underNode" class="underlay">
      <svg overflow="hidden" :width="this.dims.w" :height="this.dims.h">
        <defs>
          <linearGradient id="logo_grad_1" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" :y2="this.dims.h">
            <stop offset=".05" stop-color="var(--main-orange)"></stop>
            <stop offset=".95" stop-color="var(--dark-orange)"></stop>
          </linearGradient>
        </defs>
        <g fill="url(#logo_grad_1)">
          <rect :x="boxForBgH.x"
                :y="boxForBgH.y"
                :width="boxForBgH.w"
                :height="boxForBgH.h"></rect>
        </g>
      </svg>
    </div>
    <div ref="mainNode" class="main">
      <svg overflow="hidden" :width="this.dims.w" :height="this.dims.h">
        <defs>
          <linearGradient gradientUnits="userSpaceOnUse" id="logo_grad_2" x1="0" y1="0" x2="0" :y2="this.dims.h">
            <stop offset=".05" stop-color="var(--dark-orange)"></stop>
            <stop offset=".95" stop-color="var(--main-orange)"></stop>
          </linearGradient>
        </defs>
        <g fill="url(#logo_grad_2)">
          <path :d="pathForC"></path>
          <rect :x="boxForTopH.x"
                :y="boxForTopH.y"
                :width="boxForTopH.w"
                :height="boxForTopH.h"></rect>
          <rect :x="boxForBottomH.x"
                :y="boxForBottomH.y"
                :width="boxForBottomH.w"
                :height="boxForBottomH.h"></rect>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>

export default {
    name  : "Logo",
    props : {
        scale : {
            type    : Number,
            default : 1
        }
    },
    data() {
        return {
            refSize    : { w : 1020, h : 600 },
            refPadding : 0,
            refWidthH  : 440
        };
    },
    computed : {
        dims() {
            return {
                w : Math.ceil(this.refSize.w * this.scale),
                h : Math.ceil(this.refSize.h * this.scale)
            };
        },
        outerRadius() {
            return this.dims.h / 2;
        },
        innerRadius() {
            return this.outerRadius * 0.8;
        },
        widthOfH() {
            return this.refWidthH * this.scale;
        },
        strokeOfH() {
            return this.outerRadius - this.innerRadius;
        },
        pathForC() {
            const outerRad = this.outerRadius;
            const innerRad = this.innerRadius;
            const angle    = Math.atan2(1, 1.1);

            var pt1 = {
                x : outerRad * (1 + Math.cos(angle)),
                y : outerRad * (1 - Math.sin(angle))
            };

            var pt2 = {
                x : outerRad + innerRad * Math.cos(angle),
                y : outerRad - innerRad * Math.sin(angle)
            };

            var pt3 = {
                x : outerRad + innerRad * Math.cos(angle),
                y : outerRad + innerRad * Math.sin(angle)
            };

            var pt4 = {
                x : outerRad * (1 + Math.cos(angle)),
                y : outerRad * (1 + Math.sin(angle))
            };

            return `M${pt1.x} ${pt1.y} ` +
                   `A${outerRad} ${outerRad} 0 1 0 ${pt4.x} ${pt4.y} ` +
                   `L${pt3.x} ${pt3.y} ` +
                   `A${innerRad} ${innerRad} 0 1 1 ${pt2.x} ${pt2.y} ` +
                   `L${pt1.x} ${pt1.y}`;
        },
        boxForTopH() {
            return {
                x : this.dims.w - this.widthOfH + this.strokeOfH,
                y : 0,
                w : this.widthOfH - 2 * this.strokeOfH,
                h : (this.dims.h - this.strokeOfH) / 2
            };
        },
        boxForBottomH() {
            return {
                x : this.dims.w - this.widthOfH + this.strokeOfH,
                y : this.dims.h - (this.dims.h - this.strokeOfH) / 2,
                w : this.widthOfH - 2 * this.strokeOfH,
                h : (this.dims.h - this.strokeOfH) / 2
            };
        },
        boxForBgH() {
            return {
                x : this.dims.w - this.widthOfH,
                y : 0,
                w : this.widthOfH,
                h : this.dims.h
            };
        }
    },
    methods : {
    }
};

</script>

<style scoped>

.logo {
    position:relative;
}

.logo > .main {
    position:relative;
}

.logo > .underlay {
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
    opacity:0;
    transition:opacity 3000ms;
}

.logo:hover > .underlay {
    opacity:1;
}

</style>
